module.exports = __webpack_public_path__ + "img/logo.3413ba24.png";